import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Loader } from '../../../../Common';
import Swal from 'sweetalert2';
import { selectedUserIdSelector } from '../../../../../selectors/userSelectors';
import { useSelector } from 'react-redux';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import { useArchiveAccountMutation, useGetAccountsQuery } from '../../../../../api/accountsApi';

const MonitoredAccounts = () => {
  const selectedUserId = useSelector(selectedUserIdSelector);
  const { data: bankList = [], isLoading: isBankListLoading } = useGetAccountsQuery(selectedUserId);
  const [archiveAccount] = useArchiveAccountMutation();

  // Confirm, run the given removal request, and surface the result
  const confirmAndRemove = (e, removalRequest) => {
    e.preventDefault();
    Swal.fire({
      title: 'Are you sure?',
      text: 'This account will be removed!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!'
    }).then(async (result) => {
      if (!result.value) {
        return;
      }
      try {
        const { data } = await removalRequest();
        const { status, msg } = data;
        if (status === 'ok') {
          Swal.fire('Success!', msg, 'success');
        } else {
          Swal.fire({ icon: 'error', title: 'Oops...', text: msg });
        }
      } catch (e) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'An unexpected error occurred. Please try again later. If the error persists, please make a ticket with the engineering team.'
        });
      }
    });
  };

  /** Remove a single sub-account by its account_id */
  const handleRemoveSubAccount = (e, accountId) => confirmAndRemove(e, () => archiveAccount(accountId));

  const getStringFromExpenseType = (type) => {
    if (type === 'work only') {
      return '(W)';
    } else if (type === 'personal only') {
      return '(P)';
    } else {
      return '';
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        mt: 2
      }}>
      <Typography variant='h6'>Monitored Accounts</Typography>
      {isBankListLoading ? (
        <Loader />
      ) : (
        <Box
          sx={{
            py: 1
          }}>
          {isEmpty(bankList) ? (
            <Typography variant='body1'>Bank accounts not available</Typography>
          ) : (
            bankList.map((data, index) => (
              <div key={index}>
                <Stack
                  direction='row'
                  sx={{
                    alignItems: 'center'
                  }}>
                  <Typography
                    variant='body1'
                    sx={{
                      width: '70%'
                    }}>
                    {data.institution_name}
                  </Typography>
                  <Typography variant='body1' sx={{ color: data.linked ? 'success.main' : 'error.main' }}>
                    {data.linked ? 'Linked' : 'Unlinked'}
                  </Typography>
                </Stack>
                <Stack
                  direction='column'
                  sx={{
                    gap: 1
                  }}>
                  {data.subAccounts.map((sa, saKey) => (
                    <Stack
                      direction='row'
                      key={saKey}
                      sx={{
                        alignItems: 'center',
                        pl: 5
                      }}>
                      <Typography
                        variant='body2'
                        sx={{
                          fontWeight: 'bold'
                        }}>
                        {sa.name} xx-{sa.mask} <span>{getStringFromExpenseType(sa.expense_type)}</span>
                      </Typography>
                      <Box
                        sx={{
                          ml: 'auto',
                          mr: 3
                        }}>
                        <IconButton onClick={(e) => handleRemoveSubAccount(e, sa.account_id)} size='small'>
                          <FontAwesomeIcon icon={['fa', 'times']} />
                        </IconButton>
                      </Box>
                    </Stack>
                  ))}
                </Stack>
              </div>
            ))
          )}
        </Box>
      )}
    </Box>
  );
};

export default MonitoredAccounts;
